export default __webpack_public_path__ + "static/1337-913d51357db5a65f9c39314fef7caaaf.gif";